import React from "react";
import { createRoot } from "react-dom/client";

const componentRegistry = {};

export function registerComponent(name, component) {
  componentRegistry[name] = component;
}

function parseProps(propsString) {
  if (!propsString) return {};
  try {
    const decoded = propsString
      .replace(/&quot;/g, '"')
      .replace(/&#39;/g, "'")
      .replace(/&amp;/g, "&")
      .replace(/&lt;/g, "<")
      .replace(/&gt;/g, ">");
    return JSON.parse(decoded);
  } catch (e) {
    console.error("Failed to parse props:", e);
    return {};
  }
}

function mountComponents() {
  const targets = document.querySelectorAll("[data-react-component]");

  targets.forEach(async (el) => {
    if (el.dataset.reactMounted) return;
    el.dataset.reactMounted = "true";

    const componentName = el.dataset.reactComponent;
    const props = parseProps(el.dataset.reactProps);

    let Component = componentRegistry[componentName];

    if (!Component) {
      try {
        const module = await import(`./components/${componentName}.js`);
        Component = module.default;
      } catch (e) {
        console.error(`Component ${componentName} not found:`, e);
        return;
      }
    }

    const root = createRoot(el);
    root.render(React.createElement(Component, props));
  });
}

document.addEventListener("DOMContentLoaded", mountComponents);
document.addEventListener("turbo:load", mountComponents);
